import React from 'react';
import PropTypes from 'prop-types';
import { getResourcePath, trans } from '@spotahome/soyuz/client';

import './HomeCardBannerImage.scss';

const HomeCardBannerImage = ({ bannerName, children, isWebView }) => {
  const imageUrl = `/images/homecard-banner/${bannerName}.${
    isWebView ? 'web' : 'mobile'
  }.jpg`;
  return (
    <div className="home-card-banner-image">
      <img
        className="home-card-banner-image__img"
        src={getResourcePath(imageUrl)}
        alt={trans(`homecard.banner.${bannerName}.label`)}
      />
      <div className="home-card-banner-image__label-wrapper">{children}</div>
    </div>
  );
};

HomeCardBannerImage.propTypes = {
  bannerName: PropTypes.string,
  children: PropTypes.node,
  isWebView: PropTypes.bool
};

HomeCardBannerImage.defaultProps = {
  bannerName: '',
  children: null,
  isWebView: true
};

export default HomeCardBannerImage;
